import { db } from "../firebase";
import { collection, addDoc, query, where, getDocs } from "firebase/firestore";

export const addSponsor = async (formData) => {
    const { name, email, phone, company, comments } = formData;
    try {
        const sponsorsRef = collection(db, 'sponsors');
        const q = query(sponsorsRef, where('email', '==', email)); 

        const querySnapshot = await getDocs(q);
        if (querySnapshot.size > 0) {
            alert("This email was already used.");
            return;
        } else {
            await addDoc(collection(db, "sponsors"), {
                name,
                email,
                phone,
                company,
                comments,
                timestamp: new Date()
            });

            alert("Thank you for your interest in our project! We will get back to you soon.");
        }
    } catch (e) {
        console.error("Error adding sponsor: ", e);
        alert("Something went wrong. Please try again later.");
    }
};